export default {
  title: 'Tuotteet',
  buttons: {
    add_product: 'Lisää tuote',
  },
  modals: {
    delete_product: {
      title: 'Oletko varma',
      description:
        'Kaikki tähän tuotteeseen liittyvät nykyiset tilaukset pysyvät aktiivisina, mutta uusia tilauksia ei voi enää luoda sillä. Tätä toimintoa ei voi perua!',
    },
    delete_price: {
      title: 'Oletko varma',
      description:
        'Kaikki tähän hintaan liittyvät nykyiset tilaukset pysyvät aktiivisina, mutta uusia tilauksia ei voi enää luoda sillä. Tätä toimintoa ei voi perua!',
    },
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    failed_to_delete_product: 'Tuotteen poistaminen epäonnistui',
    product_got_deleted: 'Tuote poistettiin',
    failed_to_delete_price: 'Hinnan poistaminen epäonnistui',
    price_got_deleted: 'Hinta poistettiin',
  },
};
